import { render, staticRenderFns } from "./JavascriptComponents.vue?vue&type=template&id=8f65d132&"
import script from "./JavascriptComponents.vue?vue&type=script&lang=js&"
export * from "./JavascriptComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports